import { notification } from "antd";
import { useCallback } from "react";
import { TaskStatus } from "tm-shared/types";

interface PayloadWithComment {
    status?: TaskStatus;
    comment?: string;
    notificationMessage?: string;
}

export const useCheckCommentOnReject = () => {
    const validateAndNotify = useCallback(
        (payload: PayloadWithComment | null | undefined): boolean => {
            if (!payload) return false;

            const isRejectedWithoutComment =
                payload.status === TaskStatus.Rejected && !payload.comment;

            if (isRejectedWithoutComment) {
                notification.error({
                    message:
                        payload?.notificationMessage ||
                        "Коментар є обов'язковим при відхиленні",
                });
            }

            return isRejectedWithoutComment;
        },
        [],
    );

    const isRejectedWithoutComment = useCallback(
        (payload: PayloadWithComment | null | undefined): boolean => {
            if (!payload) return false;
            return payload.status === TaskStatus.Rejected && !payload.comment;
        },
        [],
    );

    return { validateAndNotify, isRejectedWithoutComment };
};
